import { render, staticRenderFns } from "./TabConfronti.vue?vue&type=template&id=5b88d4e2&"
import script from "./TabConfronti.vue?vue&type=script&lang=js&"
export * from "./TabConfronti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports